export default "__VITE_ASSET__DGc2UQh5__"